import React from 'react';
import { CardActions } from '@mui/material';

import { DeleteButton, ListButton, RefreshButton, ShowButton, EditButton } from 'react-admin';

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

export const OnlyShowActionsDetail = ({ basePath, data }) => (
    <CardActions style={cardActionStyle}>
        <ListButton basePath={basePath} />
        <DeleteButton basePath={basePath} record={data} />
        <RefreshButton />
    </CardActions>
);

export const OnlyShowActionsList = ({ basePath, data }) => (
    <CardActions style={cardActionStyle}>
        <RefreshButton />
    </CardActions>
);

export const OnlyShowActionsEdit = ({ basePath, data }) => (
    <CardActions style={cardActionStyle}>
        <ShowButton basePath={basePath} record={data} />
        <ListButton basePath={basePath} />
        <RefreshButton />
    </CardActions>
);

export const DontDeletectionsDetail = ({ basePath, data }) => (
    <CardActions style={cardActionStyle}>
        <EditButton basePath={basePath} record={data} />
        <ListButton basePath={basePath} />
        <RefreshButton />
    </CardActions>
);
